import {createFetchableSlice} from '../../../utils/createFetchableSlice';
import {fetchWorkAssignments} from '../../../Api';

export const workAssignmentsSlice = createFetchableSlice({
    name: 'workAssignments',
    fetchable: fetchWorkAssignments,
});

export default workAssignmentsSlice.reducer;